import FormularioDonacion from "./formulario-donacion";
import FDECaptchaGoogle from "./captcha-google";

const captchaPublicKey = document.getElementById("fde_codigo_captcha").value;
let catpcha = new FDECaptchaGoogle(captchaPublicKey);

function cargarRecaptcha() {
    if( typeof grecaptcha !== 'undefined' ) {
        grecaptcha.ready(function() {
            grecaptcha.execute(catpcha.getPublicKey(), {action: 'contact'})
                .then(function(token) {
                    catpcha.setup(token);
                })
        });
    } else {
        window.setTimeout( cargarRecaptcha, 100 );
    }
}
cargarRecaptcha();

document.addEventListener('DOMContentLoaded', function(event) {
    let formulario = new FormularioDonacion(catpcha);
});


